import { create } from 'zustand';

const useOrderStore = create((set) => ({
  orderSummary: null,
  orderDialogOpen: false,
  venueOrderSummary: null,
  venueOrderDialogOpen: false,

  setOrderSummary: (summary) => set({ orderSummary: summary }),
  setOrderDialogOpen: (open) => set({ orderDialogOpen: open }),
  setVenueOrderSummary: (summary) => set({ venueOrderSummary: summary }),
  setVenueOrderDialogOpen: (open) => set({ venueOrderDialogOpen: open }),
}));

export default useOrderStore;
